<template>
    <div class="account">
        <div class="container">
            <div class="account__wrapper">
                <AccountSideMenu></AccountSideMenu>

                <div class="account__contain faq">
                    <h5 class="account__section-title">Faq - Pytania i odpowiedzi:</h5>

                    <div class="faq__list">
                        <div v-for="(item, index) in dynamicList" :key="index" data-aos="fade-in" class="faq__item" :class="{'active': item.active}">
                            <h5 class="faq__item-title" @click="toggle(index)">
                                <span>{{ item.title }}</span>
                                <IconMinus v-if="item.active" class="faq__item-trigger"></IconMinus>
                                <IconPlus v-else  class="faq__item-trigger"></IconPlus>
                            </h5>
                            <p class="faq__item-text" :class="{'active': item.active}" data-aos="fade-in" v-if="item.active" v-html="item.text"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import AccountSideMenu from "./AccountSideMenu.vue";
import IconPlus from "../elements/icons/IconPlus.vue";
import IconMinus from "../elements/icons/IconMinus.vue";

export default {
    name: "AccountFaq",
    components: {
        AccountSideMenu,
        IconPlus,
        IconMinus
    },
    data() {
        return {
            FAQ: '/api/krainaabc/page/faq?device=www',
            faqList: [],
            elToShow: 7,
            visibleItems: document.getElementsByClassName('faq__item')
        };
    },
    computed: {
        path() {
            return this.$route.path;
        },
        dynamicList() {
            return this.faqList.slice(0, this.elToShow);
        },
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        }
    },
    methods: {
        getFaqList() {
            axios.get(this.FAQ).then((response) => {
                if (response.status === 200) {
                    if(response.data.data && response.data.data.paragraphs) {
                        response.data.data.paragraphs.forEach((item, index) => {
                            this.faqList.push({
                                id: index,
                                title: item.title,
                                text: item.text,
                                active: false
                            })
                        })
                    }
                }
            });
        },
        toggle(index) {
            this.faqList.forEach(item => {
                if(item.id === index) {
                    item.active = !item.active;
                } else {
                    item.active = false;
                }
            });
        },
        isInViewport(element) {
            const rect = element.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }
    },
    mounted() {
        this.getFaqList();

        window.addEventListener('scroll', () => {
            if(this.isInViewport(this.visibleItems[this.visibleItems.length - 1])) {
                this.elToShow++;
            }
        })

        window.gemius_event(
            '_view_',
            this.gemiusIdentifier
        );         
    }
};
</script>